import React, { useEffect, useRef, useState } from "react";
import OT from "@opentok/client";
import MicIcon from "@material-ui/icons/Mic";
import MicOffIcon from "@material-ui/icons/MicOff";
import VideocamIcon from "@material-ui/icons/Videocam";
import VideocamOffIcon from "@material-ui/icons/VideocamOff";
import ViewComfyIcon from "@material-ui/icons/ViewComfy";
import ViewCompactIcon from "@material-ui/icons/ViewCompact";
import DesktopWindowsIcon from "@material-ui/icons/DesktopWindows";
import DesktopAccessDisabledIcon from "@material-ui/icons/DesktopAccessDisabled";
import { IconButton } from "@material-ui/core";
import FullscreenIcon from "@material-ui/icons/Fullscreen";
import FullscreenExitIcon from "@material-ui/icons/FullscreenExit";
import { screenshareLayouts } from "./VonageScreenshare";
import ScreenshareOptionsPop from "./ScreenshareOptionsPop";
import SettingsIcon from "@material-ui/icons/Settings";
import ZoomOutIcon from "@material-ui/icons/ZoomOut";
import ZoomInIcon from "@material-ui/icons/ZoomIn";
export default function VonageControlpanel(props) {
  const [isMicOn, setIsMicOn] = useState(false);
  const [isCamOn, setIsCamOn] = useState(false);
  const [controlLock, setControlLock] = useState(true);
  const [isScreenshareEnabled, setIsScreenshareEnabled] = useState(false);
  const functionsRef = useRef();
  useEffect(() => {
    OT.checkScreenSharingCapability((r) => {
      setIsScreenshareEnabled(r.supported);
    });
    setTimeout(() => setControlLock(false), 2000);
    props.setFunctionsRef(functionsRef);
    return () => {
    };
  }, []);

  useEffect(() => {
    if (props.publisher && props.publisher.stream) {
      if (props.publisher.stream.hasAudio != isMicOn) setIsMicOn(props.publisher.stream.hasAudio);
      if (props.publisher.stream.hasVideo != isCamOn) setIsCamOn(props.publisher.stream.hasVideo);
    }
    if (props.session) {
      props.session.on("streamPropertyChanged", bindPropertyChanges);
    }
    functionsRef.current = {
      setControlLock
    };
    return () => {
      if (props.session) {
        props.session.off("streamPropertyChanged", bindPropertyChanges);
      }
    };
  });
  function bindPropertyChanges({ changedProperty, newValue, stream }) {
    const { publisher } = props;
    if (publisher && stream == publisher.stream) {
      if (changedProperty == "hasAudio") {
        setIsMicOn(newValue);
      } else if (changedProperty == "hasVideo") {
        setIsCamOn(newValue);
      }
      if (!publisher.stream.hasAudio && !publisher.stream.hasVideo) {
        props.stopPublisher();
      }
    }
  }
  function toggleAudio() {
    if (props.publisher) {
      props.publisher.publishAudio(!isMicOn);
      setControlLock(true);
      setTimeout(() => setControlLock(false), 500);
    } 
    else{
      setControlLock(true);
      props.startPublisher("audioOnly", () => setControlLock(false));
    } 

  }
  function toggleVideo() {
    if (props.publisher) {
      props.publisher.publishVideo(!isCamOn);
      setControlLock(true);
      setTimeout(() => setControlLock(false), 500);
    } 
    else{
      setControlLock(true);
      props.startPublisher("videoOnly", () => setControlLock(false));
    } 
  }
  return (
    <div id="vonage-controlpanel" className={props.showControlbar ? "cb-fade showup" : "cb-fade hide"}>
      {props.session && props.session.capabilities && props.session.capabilities.publish === 1 && (!props.backstage || props.view) ? (
        <React.Fragment>
          <div className="vonage-icon-button">
            <IconButton disabled={controlLock || props.disableControls} onClick={toggleAudio}>
              {isMicOn ? <MicIcon /> : <MicOffIcon />}
            </IconButton>
          </div>
          <div className="vonage-icon-button">
            <IconButton disabled={controlLock || props.disableControls} onClick={toggleVideo}>
              {isCamOn ? <VideocamIcon /> : <VideocamOffIcon />}
            </IconButton>
          </div>
          <div className="vonage-icon-button">
            <IconButton onClick={props.toggelDeviceSettings}>
              <SettingsIcon />
            </IconButton>
          </div>
          {isScreenshareEnabled ? (
            <div className="vonage-icon-button">
              {props.isSharingMyScreen ? (
                <IconButton onClick={props.stopScreenshare}>
                  <DesktopAccessDisabledIcon />
                </IconButton>
              ) : (
                <IconButton disabled={props.isSomeoneSharingScreen || props.disableControls} onClick={props.startScreenshare}>
                  <DesktopWindowsIcon />
                </IconButton>
              )}
            </div>
          ) : null}
        </React.Fragment>
      ) : null}
      {props.allowFullscreen && ((props.session && props.session.capabilities && props.session.capabilities.publish === 1) || props.streams.length > 0 || props.fullscreen) ? (
        <div className="vonage-icon-button">
          <IconButton onClick={props.toggleFullscreen}>{props.fullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}</IconButton>
        </div>
      ) : null}
      {!props.moderatorLock && props.screensharePublisher ? (
        <div className="vonage-icon-select">
          <ScreenshareOptionsPop onChange={(val) => props.changeScreenshareLayout(val)} layout={props.screenshareLayout} />
        </div>
      ) : null}
    </div>
  );
}
